import React from 'react';

import { Navbar, Nav, NavItem } from 'reactstrap';

const Footer = () => {
  return (
    <Navbar>
      <Nav navbar>
        <NavItem>&#169; SCG PROMPT PLUS</NavItem>
      </Nav>
    </Navbar>
  );
};

export default Footer;
